import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import HashIdForm from './components/HashIdForm';
import TeamDetails from './components/TeamDetails';
import Scoreboard from './components/Scoreboard';
import Message from './components/Message';
import Navbar from './components/Navbar';
import About from './components/About';

import { TeamProvider } from './components/TeamContext';
import Welcome from './components/Welcome';
import Episode0 from './components/Episode0';
import Episode1 from './components/Episode1';
import Episode1_2 from './components/Episode1_2';
import Episode2 from './components/Episode2';

import axios from 'axios';
import { TEAM_ENDPOINT } from './constants/apiConfig';

function App() {
  const [hashId, setHashId] = useState('');
  const [team, setTeam] = useState(null);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [theme, setTheme] = useState('system'); // Added theme state

  // Function to clear the message manually (for close button)
  const clearMessage = () => {
    setMessage({ text: '', type: '' });
  };

  // Automatically dismiss the message after 5 seconds
  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        clearMessage();
      }, 5000); // 5 seconds

      return () => clearTimeout(timer); // Clear timeout if component is unmounted or message changes
    }
  }, [message]);

  const handleGetTeamInfo = async () => {
    if (!hashId) {
      setMessage({ text: 'Hash ID cannot be empty', type: 'error', });
      return;
    }

    try {
      const response = await axios.get(`${TEAM_ENDPOINT}/${hashId}`);

      if (!response.data) {
        // If no team found, create an empty team object
        setTeam({});
      } else {
        // Team found with teamName -> Show team details              
        setTeam(response.data);
        //console.log(response.data);
        clearMessage();
      }
    } catch (err) {
      console.log(err);
      setMessage({ text: 'An error occurred while fetching the team info', type: 'error' });
      setTeam(null);
    }
  };

    const handleSaveTeamDetails = async (updatedTeam) => {
      try {
        // Patch request to save team name, payment gateway URL, and payment processor URL
        await axios.patch(`${TEAM_ENDPOINT}`, { ...updatedTeam, id: `${hashId}` });

        // Update the team state with the new values
        setTeam({ ...updatedTeam });

        setMessage({ text: 'Datos actualizados', type: 'success' });
      } catch (err) {
        setMessage({ text: 'An error occurred while saving the team details', type: 'error' });
      }
    };

    return (
      <div className="min-h-screen">
        <Router>
            <Navbar theme={theme} setTheme={setTheme} />   
            <div className="bg-grey-200 dark:bg-gray-900">
              <h1 className="font-lustra text-5xl text-white text-center mb-8">Galactic Payments
                <p className="mt-3 text-xl font-thin leading-6 text-white">
                  Who needs instant payments when you’ve got the entire universe to wait?
                </p>
              </h1>
            </div>
    

          <div className="lg:w-3/5 md:w-4/5 sm:w-full mx-auto bg-blue-950 p-4 rounded-lg shadow-md mb-8">
            {/* Define the routes for different pages */}
            <Routes>
              <Route path="/" element={
                <>
                  <Scoreboard />
                  {message.text && <Message message={message.text} type={message.type} onClose={clearMessage} />}
                </>
                }
              />
              <Route
                path="/team"
                element={
                  <>
                    {/* Hash ID form and error message */}
                    {!team && (
                      <HashIdForm
                        hashId={hashId}
                        setHashId={setHashId}
                        handleGetTeamInfo={handleGetTeamInfo}
                      />
                    )}

                    {/* Show team details if the team data is available */}
                    {team && (
                      team.name ? (
                        <TeamProvider
                          initialTeam={team}
                          handleSaveTeamDetails={handleSaveTeamDetails}
                        >
                          <Welcome />
                          <Episode0 />
                          {team.nullplatform_application_nrn && (
                            <Episode1 />
                          )}
                          {team.nullplatform_application_nrn && team.payment_gateway_url && (
                            <Episode1_2 />
                          )}
                          {team.nullplatform_application_nrn && team.payment_gateway_url && team.drawio_url && (
                            <Episode2 />
                          )}
                        </TeamProvider>
                      ) : (
                        <TeamDetails
                          team={team}
                          handleSaveTeamDetails={handleSaveTeamDetails}
                        />
                      )
                    )}
                    {message.text && <Message message={message.text} type={message.type} onClose={clearMessage} />}
                  </>
                }
              />
              <Route
                path="/about" element={
                  <About />
                }
              />
            </Routes>
          </div>
        </Router>
       </div>
    );
}

export default App;
